module.exports = __webpack_public_path__ + "static/basket_cover-ffc69efbdf272d9364c62159526b4113.png";